import React, { forwardRef } from "react"
import styled, { css } from "styled-components"
import { Link } from "gatsby"

export const primaryButtonArrowStyles = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  height: ${props => props.theme.mobileVW(40)};
  min-width: ${props => props.theme.mobileVW(120)};

  padding: 0 ${props => props.theme.mobileVW(18)};

  background-color: ${props => props.theme.colors.light};
  border: ${props => props.theme.mobileVW(2)} solid
    ${props => props.theme.colors.light};
  border-radius: ${props => props.theme.mobileVW(24)};
  color: ${props => props.theme.colors.dark};

  .label {
    font-size: ${props => props.theme.fontSizes.mobile.s};
    line-height: 1;
  }

  ${props => props.theme.above.desktop`
        height: ${props.theme.desktopVW(40)};
        min-width: ${props.theme.desktopVW(150)};

        padding: 0 ${props.theme.desktopVW(18)};

        border: ${props.theme.desktopVW(2)} solid ${props.theme.colors.light};
        border-radius: ${props.theme.desktopVW(24)};

        &:hover {
            opacity: 1;

            background-color: ${props.theme.colors.white};
            border-color: ${props.theme.colors.white};
            color: ${props.theme.colors.dark};
        }

        .label {
            font-size: ${props.theme.fontSizes.desktop.m};
        }
    `}
`

const Button = styled(Link)`
  ${props => props.theme.above.desktop`
        transition: all .5s cubic-bezier(.16,1.08,.38,.98);

        &:hover, &.hover {
            opacity: 0.25;

            .arrow {
                margin-left: ${props.theme.desktopVW(25)};

                &:before {
                    transform: translateY(-50%) translateX(-${props.theme.desktopVW(
                      24
                    )});
                    width: ${props.theme.desktopVW(23)};
                }
            }
        }
    `}
`

const Label = styled.span`
  display: inline-block;
  vertical-align: middle;

  font-family: ${props => props.theme.fontFamilies.nbRegular};
  font-size: ${props => props.theme.fontSizes.mobile.xs};
  line-height: 1.5;

  text-transform: uppercase;

  ${props => props.theme.above.desktop`
        font-size: ${props.theme.fontSizes.desktop.m};
    `}
`

const Arrow = styled.div`
  position: relative;

  margin-left: ${props => props.theme.mobileVW(15)};

  ${props => props.theme.styles.inlineBlock.verCen};

  width: 0;
  height: 0;

  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 4px solid currentColor;

  &:before {
    content: "";
    position: absolute;

    top: 50%;
    left: 0;

    transform: translateY(-50%) translateX(-12px);

    width: 8px;
    height: 2px;

    background-color: currentColor;
  }

  ${props => props.theme.above.desktop`
        margin-left: ${props.theme.desktopVW(15)};

        border-top: ${props.theme.desktopVW(5)} solid transparent;
        border-bottom: ${props.theme.desktopVW(5)} solid transparent;
        border-left: ${props.theme.desktopVW(5)} solid currentColor;

        transition: all .5s cubic-bezier(.16,1.08,.38,.98);

        &:before {
            transform: translateY(-50%) translateX(-${props.theme.desktopVW(
              13
            )});
            
            width: ${props.theme.desktopVW(13)};
            height: 1px;

            transition: all .5s cubic-bezier(.16,1.08,.38,.98);
        }
    `}
`

const ButtonArrow = ({ className, label, to, modal, onClick }, ref) => {
  if (modal) {
    return (
      <Button
        ref={ref}
        className={`button ${className && className}`}
        to={to}
        onClick={onClick}
        state={{
          modal: modal.modal,
          formInput: modal.formInput,
        }}
      >
        <Label className="label">{label}</Label>
        <Arrow direction="right" className="arrow" />
      </Button>
    )
  } else {
    return (
      <Button
        ref={ref}
        className={`button ${className && className}`}
        to={to}
        onClick={onClick}
      >
        <Label className="label">{label}</Label>
        <Arrow direction="right" className="arrow" />
      </Button>
    )
  }
}

export default forwardRef(ButtonArrow)
